import { render, staticRenderFns } from "./epItem.vue?vue&type=template&id=69135904&"
import script from "./epItem.vue?vue&type=script&lang=js&"
export * from "./epItem.vue?vue&type=script&lang=js&"
import style0 from "./epItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports